// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-data-cards-container {
  padding: 10px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  /* height: 100vh; */
  max-width: 650px;
  margin-left: auto;
  margin-right: auto;
  /* overflow-y: scroll; */
}
.input-style {
  margin: 8px 0;
  width: 30px;
}
.input-style > span {
  pointer-events: none;
}
.card-loading {
  width: 100%;
  height: 200px;
  border: dashed #777 1px;
}
.card-grid {
  height: 200px;
  width: 100%;
  display: flex;
  flex-direction: row;
  /* justify-content: space-between; */
}
.card-grid-mobile {
  /* height: 200px; */
  width: 100%;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
}
.card-grid-new {
  background: #dcffcf;
}
.card-grid-update {
  background: #fcffdb;
}
.left-side-card {
  height: 150px;
  width: 150px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.left-side-card-mobile {
  /* height: 150px; */
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.left-side-card > .card-img-container {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.left-side-card-mobile > .card-img-container {
  width: 100%;
  cursor: pointer;
}
.card-img {
  width: 100%;
  min-width: 108px;
}
.right-side-card {
  /* border: solid black 1px; */
  width: 100%;
  max-width: 410px;
  height: 150px;
  overflow-y: scroll;
}
.right-side-card > form {
  margin-right: 12px;
}
.controls-style {
  width: 30px;
  /* flex: 1; */
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  margin-left: 12px;
}
.upload-new-image {
  /* width: 115px; */
  font-size: 12px;
  align-self: center;
  flex: 1 1;
  margin: 10px;
}
.more-info-container {
  overflow-y: scroll;
  max-height: 300px;
  margin: 10px 0;
}
.more-info-item {
  width: 100%;
  /* height: 150px; */
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.more-info-item-mobile {
  width: 100%;
  /* height: 300px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.more-info-meta-card {
  /* border: solid black 1px;
    width: 100%;
    background: #ddd; */
  flex: 1 1;
}
.progress-dialog-background {
  position: fixed;
  padding: 20px;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 1;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.progress-dialog-foreground {
  background: white;
  padding: 30px;
  width: 100%;
  max-width: 500px;
}
.progress-dialog-foreground > .ant-card-body {
  display: flex;
  flex-direction: column;
}
.progress-items-container {
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
  max-height: 300px;
  margin: 10px 0;
}
.progress-item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 50px;
  margin: 10px;
}
.progress-item-mobile {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 50px;
  margin: 10px;
}
.progress-item-mobile > img {
  height: 100%;
  margin-right: 20px;
}
.ads-navbar {
  display: flex;
  align-items: baseline;
}
.ads-navbar > h2 {
  margin-left: 12px;
  flex: 1 1;
}
.ads-navbar > span {
  flex: 1 1;
  max-width: 290px;
}
.ads-navbar-mobile {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.metadata-forms > div {
  width: 100%;
}
.viewlist-root {
  overflow-x: scroll;
  width: 100%;
  /* height: 100vh; */
}
/* fix for table header still showing above More Info */
.viewlist-root .ant-table-sticky-holder {
  z-index: 0;
}
.viewlist-root .ant-table-sticky-header {
  z-index: 0;
}

.viewlist-column-actions {
  /* text-align: center; */
  background: rgb(133, 139, 192);
}
.viewlist-column-actions > div > * {
  margin: 8px 0;
}
.image-upload-button {
  display: flex;
  width: 100%;
  justify-content: center;
}
.image-upload-button-mobile {
  position: fixed;
  right: 0;
  bottom: 0;
  background: #1890ff;
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/dist/style/ads_editor.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,oCAAoC;AACtC;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,SAAO;EACP,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE;;uBAEqB;EACrB,SAAO;AACT;AACA;EACE,eAAe;EACf,aAAa;EACb,WAAW;EACX,aAAa;EACb,OAAO;EACP,MAAM;EACN,UAAU;EACV,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,SAAO;AACT;AACA;EACE,SAAO;EACP,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;AACA,uDAAuD;AACvD;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".image-data-cards-container {\n  padding: 10px;\n  display: flex;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  /* height: 100vh; */\n  max-width: 650px;\n  margin-left: auto;\n  margin-right: auto;\n  /* overflow-y: scroll; */\n}\n.input-style {\n  margin: 8px 0;\n  width: 30px;\n}\n.input-style > span {\n  pointer-events: none;\n}\n.card-loading {\n  width: 100%;\n  height: 200px;\n  border: dashed #777 1px;\n}\n.card-grid {\n  height: 200px;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  /* justify-content: space-between; */\n}\n.card-grid-mobile {\n  /* height: 200px; */\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  /* justify-content: space-between; */\n}\n.card-grid-new {\n  background: #dcffcf;\n}\n.card-grid-update {\n  background: #fcffdb;\n}\n.left-side-card {\n  height: 150px;\n  width: 150px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.left-side-card-mobile {\n  /* height: 150px; */\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.left-side-card > .card-img-container {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n.left-side-card-mobile > .card-img-container {\n  width: 100%;\n  cursor: pointer;\n}\n.card-img {\n  width: 100%;\n  min-width: 108px;\n}\n.right-side-card {\n  /* border: solid black 1px; */\n  width: 100%;\n  max-width: 410px;\n  height: 150px;\n  overflow-y: scroll;\n}\n.right-side-card > form {\n  margin-right: 12px;\n}\n.controls-style {\n  width: 30px;\n  /* flex: 1; */\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  margin-left: 12px;\n}\n.upload-new-image {\n  /* width: 115px; */\n  font-size: 12px;\n  align-self: center;\n  flex: 1;\n  margin: 10px;\n}\n.more-info-container {\n  overflow-y: scroll;\n  max-height: 300px;\n  margin: 10px 0;\n}\n.more-info-item {\n  width: 100%;\n  /* height: 150px; */\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.more-info-item-mobile {\n  width: 100%;\n  /* height: 300px; */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n}\n.more-info-meta-card {\n  /* border: solid black 1px;\n    width: 100%;\n    background: #ddd; */\n  flex: 1;\n}\n.progress-dialog-background {\n  position: fixed;\n  padding: 20px;\n  width: 100%;\n  height: 100vh;\n  left: 0;\n  top: 0;\n  z-index: 1;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.progress-dialog-foreground {\n  background: white;\n  padding: 30px;\n  width: 100%;\n  max-width: 500px;\n}\n.progress-dialog-foreground > .ant-card-body {\n  display: flex;\n  flex-direction: column;\n}\n.progress-items-container {\n  display: flex;\n  flex-wrap: wrap;\n  overflow-y: scroll;\n  max-height: 300px;\n  margin: 10px 0;\n}\n.progress-item {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 50px;\n  margin: 10px;\n}\n.progress-item-mobile {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 50px;\n  margin: 10px;\n}\n.progress-item-mobile > img {\n  height: 100%;\n  margin-right: 20px;\n}\n.ads-navbar {\n  display: flex;\n  align-items: baseline;\n}\n.ads-navbar > h2 {\n  margin-left: 12px;\n  flex: 1;\n}\n.ads-navbar > span {\n  flex: 1;\n  max-width: 290px;\n}\n.ads-navbar-mobile {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n.metadata-forms > div {\n  width: 100%;\n}\n.viewlist-root {\n  overflow-x: scroll;\n  width: 100%;\n  /* height: 100vh; */\n}\n/* fix for table header still showing above More Info */\n.viewlist-root .ant-table-sticky-holder {\n  z-index: 0;\n}\n.viewlist-root .ant-table-sticky-header {\n  z-index: 0;\n}\n\n.viewlist-column-actions {\n  /* text-align: center; */\n  background: rgb(133, 139, 192);\n}\n.viewlist-column-actions > div > * {\n  margin: 8px 0;\n}\n.image-upload-button {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n}\n.image-upload-button-mobile {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  background: #1890ff;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
